// @flow

import * as React from 'react';

import { Cloud } from './Cloud';
import { Ground } from './Ground';
import { Place } from './Place';
import { Sky } from './Sky';
import Uriko from './Uriko';
import { Wagon } from './Wagon';

class Background extends React.PureComponent<{
  colorIndex: number,
  weather: number,
  place: number,
  wagon: number,
  scale: number,
  soldout: boolean,
}> {
  render() {
    return (
      <React.Fragment>
        <Sky colorIndex={this.props.colorIndex} />
        <Cloud weather={this.props.weather} />
        <Ground weather={this.props.weather} />
        <Place place={this.props.place} />
        <Wagon soldout={this.props.soldout} wagon={this.props.wagon} scale={this.props.scale} />
        {!this.props.soldout && <Uriko scale={this.props.scale} />}
      </React.Fragment>
    );
  }
}

export default Background;
